//引入vue
import Vue from 'vue';
//全局引入vueX
import Vuex from 'vuex';


import mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';

//全局注册vueX
Vue.use(Vuex);
//全局引用cookie方法类
import cookie from '../../static/js/cookie';

const userInfo = {
  name: cookie.getCookie('name'),
  token: cookie.getCookie('token') || '',
  uid: cookie.getCookie('uid') || '',
  part: cookie.getCookie('part') || '',
  mid: cookie.getCookie('mid') || '',
  id: cookie.getCookie('id') || '',
};


const person = {
  person:{}
};

const org = {
  org:{}

};
const url = '';



const state = {
  userInfo, person, org, url
}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});








// WEBPACK FOOTER //
// ./src/store/index.js